// @ts-nocheck
import { getPageByUrl } from "@insite/client-framework/Services/ContentService";
import constants from "@store/constants";
import { GetBlogCategoryFeaturedArticleApiParameter } from "@store/Framework/Services/BlogService";
import { BlogCategoryFeaturedArticleCollectionModel } from "@store/Framework/Types/ApiModels";
import { ApiHandler, createHandlerChainRunner } from "@toolkit/Modules/client-framework/HandlerCreator";
import { getContextData } from "@toolkit/Modules/client-framework/Store/Data/Pages/PagesActionCreators";

type HandlerType = ApiHandler<GetBlogCategoryFeaturedArticleApiParameter, BlogCategoryFeaturedArticleCollectionModel>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter, type: constants.blog.getDataViewType.featuredArticle } as any; // 'type' is neccessary to differentiate dataView (cache) keys
};

export const DispatchBeginLoadBlogCategoryFeaturedArticle: HandlerType = props => {
    props.dispatch({
        type: "Data/Pages/BeginLoadPages",
        parameter: props.apiParameter as any,
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getPageByUrl(props.apiParameter.pageLink);
};

export const DispatchCompleteLoadBlogCategoryFeaturedArticle: HandlerType = props => {
    const state = props.getState();

    props.dispatch({
        type: "Data/Pages/CompleteLoadPages",
        parameter: props.apiParameter as any,
        collection: {
            pages: [props.apiResult.page] as any,
            pagination: {} as any,
        },
        links: state.links,
        ...getContextData(state),
    });
};

export const chain = [
    PopulateApiParameter,
    DispatchBeginLoadBlogCategoryFeaturedArticle,
    RequestDataFromApi,
    DispatchCompleteLoadBlogCategoryFeaturedArticle,
];

const loadBlogCategoryFeaturedArticle = createHandlerChainRunner(chain, "LoadBlogCategoryFeaturedArticle");
export default loadBlogCategoryFeaturedArticle;
